
import { Card, CardContent } from "@/components/ui/card";
import { useApplicationStatus } from "@/hooks/use-application-status";
import { LoadingState } from "./status/LoadingState";
import { EmptyState } from "./status/EmptyState";
import { Button } from "@/components/ui/button";
import { FileEdit, Clock, Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const ApplicationStatus = () => {
  const { data: application, isLoading } = useApplicationStatus();
  const navigate = useNavigate();
  
  if (isLoading) {
    return <LoadingState />;
  }
  
  if (!application) {
    return <EmptyState />;
  }

  const progress = application.progress || 0;
  const status = application.status || 'draft';
  const isSubmitted = status === 'submitted';
  
  return (
    <Card className="border">
      <CardContent className="pt-6">
        <h3 className="text-2xl font-bold mb-4">Track your PEO application</h3>
        
        <div className="space-y-6">
          <div>
            <div className="flex justify-between items-center mb-2">
              <p className="text-sm font-medium">Overall Progress</p>
              <span className="text-sm font-medium text-primary">{progress}%</span>
            </div>
            <div className="h-2.5 w-full bg-slate-100 rounded-full overflow-hidden">
              <div 
                className="h-full bg-primary transition-all duration-500 ease-in-out" 
                style={{ width: `${progress}%` }}
              ></div>
            </div>
          </div>
          
          <div className="p-4 rounded-lg bg-slate-100 space-y-2">
            <div className="flex items-center gap-2">
              {isSubmitted ? (
                <Clock className="h-5 w-5 text-gray-600" />
              ) : (
                <FileEdit className="h-5 w-5 text-gray-600" />
              )}
              <h3 className="font-medium">
                {isSubmitted ? 'Under Review' : 'Draft'}
              </h3>
            </div>
            <p className="text-sm text-muted-foreground">
              {isSubmitted 
                ? 'Your application is being reviewed' 
                : 'Continue completing your application'
              }
            </p>
          </div>
          
          <div className="flex justify-between items-center pt-2">
            <div>
              <p className="text-sm font-bold">Next Step</p>
            </div>
            <Button
              variant="outline"
              onClick={() => navigate(isSubmitted ? '/quotes' : '/application')}
              className="gap-2"
            >
              {isSubmitted ? (
                <>
                  <Eye className="h-4 w-4" />
                  View Quotes
                </>
              ) : (
                <>
                  <FileEdit className="h-4 w-4" />
                  Continue Application
                </>
              )}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
